export default "/images/404.png?a426671b6d8622fda7358ce86cdddace";